import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { kebabCase } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
const _getPaths = function getPaths(root) {
  let paths = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const childPaths = [];
  const keys = Object.keys(root);
  keys.forEach(key => {
    const child = root[key];
    const keyPaths = paths.concat([child.title]);
    if (child.children) {
      const children = _getPaths(child.children, keyPaths);
      childPaths.push(...children);
    } else {
      childPaths.push(keyPaths);
    }
  });
  return childPaths;
};
const selectionFromNestedPicker = root => {
  const result = {};
  const paths = _getPaths(root || {});
  const _paths = _slicedToArray(paths, 1),
    issueItem = _paths[0];
  if (paths.length !== 1) {
    result.item = "".concat(paths.length, " Items");
  } else {
    result.item = issueItem.pop();
    result.group = issueItem.pop();
  }
  return result;
};
const selectionFromSinglePicker = tree => {
  if (!tree) {
    return '';
  }
  const _Object$keys = Object.keys(tree),
    _Object$keys2 = _slicedToArray(_Object$keys, 1),
    key = _Object$keys2[0];
  return (tree[key] || {}).title;
};
const IssuesRow = props => {
  const data = props.data,
    hasActions = props.hasActions,
    index = props.index,
    isSelected = props.isSelected,
    onSelect = props.onSelect,
    onClick = props.onClick;
  const handleClick = onClick.bind(null, data.reportDocumentID, data.id);
  const items = useMemo(() => selectionFromNestedPicker(data.content.itemCollection), [data.content.itemCollection]);
  return /*#__PURE__*/React.createElement("tr", {
    className: "t-ir-".concat(index),
    style: {
      height: '30px'
    }
  }, hasActions ? /*#__PURE__*/React.createElement("td", {
    "aria-label": "select-issue-checkbox",
    style: {
      width: '1px',
      verticalAlign: 'middle'
    }
  }, /*#__PURE__*/React.createElement("input", {
    className: "t-ir-check",
    type: "checkbox",
    checked: isSelected,
    onChange: event => onSelect(data.id, event)
  })) : /*#__PURE__*/React.createElement("td", {
    "aria-label": "disabled-select-document-checkbox",
    style: {
      width: '1px',
      verticalAlign: 'middle'
    }
  }), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
    /* eslint-disable react/jsx-indent-props */
    className: "t-ir-label t-ir-label-".concat(kebabCase(data.content.label)),
    role: "link",
    tabIndex: "0",
    onClick: handleClick,
    onKeyPress: handleClick
    /* eslint-enable react/jsx-indent-props */
  }, data.content.label)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
    className: "t-ir-title",
    role: "link",
    tabIndex: "0",
    onClick: handleClick,
    onKeyPress: handleClick
  }, data.content.title)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
    className: "t-ir-issue-items",
    role: "link",
    tabIndex: "0",
    onClick: handleClick,
    onKeyPress: handleClick
  }, items.item, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("small", null, items.group))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
    className: "t-ir-issue-severity",
    role: "link",
    tabIndex: "0",
    onClick: handleClick,
    onKeyPress: handleClick
  }, selectionFromSinglePicker(data.content.severity))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
    className: "t-ir-issue-status",
    role: "link",
    tabIndex: "0",
    onClick: handleClick,
    onKeyPress: handleClick
  }, selectionFromSinglePicker(data.content.status))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
    className: "t-ir-first-name",
    role: "link",
    tabIndex: "0",
    onClick: handleClick,
    onKeyPress: handleClick
  }, "".concat(data.firstName, " ").concat(data.lastName))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
    className: "t-ir-created",
    role: "link",
    tabIndex: "0",
    onClick: handleClick,
    onKeyPress: handleClick
  }, moment(data.created).format('MM/DD/YYYY'))));
};
IssuesRow.propTypes = {
  data: PropTypes.shape({
    content: PropTypes.shape({
      itemCollection: PropTypes.shape({}),
      label: PropTypes.string,
      severity: PropTypes.shape({}),
      status: PropTypes.shape({}),
      title: PropTypes.string
    }),
    id: PropTypes.string,
    created: PropTypes.string,
    firstName: PropTypes.string,
    label: PropTypes.string,
    lastName: PropTypes.string,
    reportDocumentID: PropTypes.string,
    title: PropTypes.string
  }).isRequired,
  hasActions: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired
};
export default IssuesRow;